import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { LoaderService } from '@otas/core/services/loader.service';
import { ActivationEnd, Router } from '@angular/router';

@Injectable()
export class LoaderSpinnerInterceptor implements HttpInterceptor {
    counter = 0;
    constructor(router: Router, private loaderService: LoaderService) {
        router.events.subscribe(event => {
            // An event triggered at the end of the activation part of the Resolve phase of routing.
            if (event instanceof ActivationEnd) {
                // Cancel the loader on route change
                this.counter = 0;
                this.loaderService.hide();
            }
        });
    }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (next.handle(req)) {
            this.loaderService.show();
            this.counter++;
            return next.handle(req).pipe(
                tap({
                    next: (e) => {
                        if (this.counter > 0) {
                            this.counter--;
                        }
                        if (this.counter === 0) {
                            this.loaderService.hide();
                        }
                    }, error: (err: HttpErrorResponse) => {
                        this.counter--;
                        if (this.counter === 0) {
                            this.loaderService.hide();
                        }
                    }
                }),
            );
        } else {
            return next.handle(req)
        }

    }
}
